(() => {
  const roots = document.querySelectorAll('[data-jos5k-campaign]');
  roots.forEach((root) => {
    const end = root.dataset.endDate;
    const days = root.querySelector('[data-days-remaining]');
    if (!end || !days) return;
    const endTime = Date.parse(end);
    if (Number.isNaN(endTime)) return;
    const remaining = Math.max(0, Math.ceil((endTime - Date.now()) / 86400000));
    days.textContent = remaining.toLocaleString();
  });
})();
